import { ResponseMsg } from '@shared/types/admin/agent';

export const isErrorResponse = (response: unknown): response is { error: unknown } => {
  return typeof response === 'object' && response !== null && 'error' in response;
};

export const createSquadError = (
  operation: 'create' | 'delete' | 'update' | 'setDefault',
  message: string,
  error?: unknown,
): ResponseMsg => {
  if (error) {
    console.error(`Squad ${operation} failed:`, error);
  }
  return {
    message,
    type: 'error',
  };
};

export const handleSquadOperationResult = (
  response: unknown,
  successMessage: string,
  errorMessage: string,
): ResponseMsg => {
  if (isErrorResponse(response)) {
    console.error('Squad operation failed:', response.error);
    return {
      message: errorMessage,
      type: 'error',
    };
  }

  return {
    message: successMessage,
    type: 'success',
  };
};

export const createSuccessResponse = (message: string): ResponseMsg => ({
  message,
  type: 'success',
});

export const createErrorResponse = (message: string, error?: unknown): ResponseMsg => {
  if (error) {
    console.error('Operation failed:', error);
  }
  return {
    message,
    type: 'error',
  };
};
